import styles from "./testCaseIncomingItem.module.scss";
import { Popup } from "../../../shared/components/popup/popup";
import copyIcon from "../../../shared/images/copy.svg";
import editIcon from "../../../shared/images/edit.svg";
import deleteIcon from "../../../shared/images/delete.svg";
import { ReactComponent as MenuIcon } from "../../../shared/images/menu.svg";
import {
  useRef,
  useState
} from "react";
import { useTranslation } from "react-i18next";
import { TestCaseIncoming } from "../../../types/testCaseIncomingTypes";
import { MethodType } from "../../../shared/components/methodType/methodType";
import infoIcon from "../../../shared/images/info.svg";
import {
  useDispatch,
  useSelector
} from "react-redux";
import {
  AppDispatch,
  RootState
} from "../../../store";
import { setSelectedTestCaseIncoming } from "../../../store/slices/testCaseIncomingSlice";

type TestCaseIncomingItem = {
  testCaseIncoming: TestCaseIncoming;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
}

export const TestCaseIncomingItem = ({ testCaseIncoming, onEditClick, onDeleteClick, onCopyClick }: TestCaseIncomingItem) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();

  const selectedTestCaseIncoming = useSelector((state: RootState) => state.testCaseIncomingSlice.selectedTestCaseIncoming);

  const menuContainer = useRef<HTMLDivElement>(null);

  const [showMenu, setShowMenu] = useState<boolean>(false);

  const onClickMenuIcon = (): void => {
    setShowMenu(!showMenu);
  }

  const closeMenu = (): void => {
    setShowMenu(false);
  }

  const copyClick = () => {
    onCopyClick();
    closeMenu();
  }

  const editClick = () => {
    onEditClick();
    closeMenu();
  }

  const deleteClick = () => {
    onDeleteClick();
    closeMenu();
  }

  const onClickTestCase = (): void => {
    if (selectedTestCaseIncoming.id !== testCaseIncoming.id) {
      dispatch(setSelectedTestCaseIncoming(testCaseIncoming));
    }
  }

  const getClassNameContainer = (): string => {
    let result = styles.container;

    if (showMenu) {
      result += ` ${styles.showMenu}`;
    }

    if (selectedTestCaseIncoming.id === testCaseIncoming.id) {
      result += ` ${styles.selected}`;
    }

    return result;
  }

  return (
    <div className={getClassNameContainer()}
         onClick={onClickTestCase}>
      <div className={styles.info}>
        <div className={styles.methodType}>
          <MethodType methodId={testCaseIncoming.methodId}/>
        </div>
        <span>{testCaseIncoming.name}</span>
      </div>
      <div className={styles.actions}>
      {!!testCaseIncoming.description && (
          <img title={testCaseIncoming.description} src={infoIcon} alt=""/>
        )}
        <div className={styles.menu} ref={menuContainer}>
          <div className={styles.menuIcon}
               onClick={onClickMenuIcon}>
            <MenuIcon/>
          </div>
          <Popup isShow={showMenu}
                 classContainer={styles.popup}
                 left={-70}
                 top={5}
                 parent={menuContainer.current}
                 onClose={closeMenu}
                 child={
                   <>
                     <div className={styles.item}
                          onClick={copyClick}>
                       <img src={copyIcon} alt=""/>
                       {t("common.copy")}
                     </div>
                     <div className={styles.item}
                          onClick={editClick}>
                       <img src={editIcon} alt=""/>
                       {t("common.edit")}
                     </div>
                     <div className={styles.item}
                          onClick={deleteClick}>
                       <img src={deleteIcon} alt=""/>
                       {t("common.delete")}
                     </div>
                   </>
                 }
          />
        </div>
      </div>

    </div>
  );
}